import BaseLayer from "./BaseLayer";
import {drawRectangle, imagetoCanvasPosHelper, plotCounties} from "../utils/map_utils";
import {TileViewerConstants} from "../../../utils/const";

class RescanIslands extends BaseLayer {
    id = "rescanIslands";
    label = "Rescan Islands";
    defaultVisible = this.props.tileViewerState[this.id];

    onFeatureSelect = () => undefined;

    draw = () => new Promise((resolve, reject) => {
        let {islands, deviceSettings, rescanIslands, textColor} = this.props;
        let {y_fields} = this.props.slide;
        let index = 0;
        if (rescanIslands) {
            for (let i = 0; i < rescanIslands.length; i++) {
                let rectStartPoint = imagetoCanvasPosHelper({device_settings: deviceSettings}, this.props.slide,
                    (rescanIslands[i]["islandBoundary"])["x"], y_fields -
                    (rescanIslands[i]["islandBoundary"])["y"]);
                let rectEndPoint = imagetoCanvasPosHelper({device_settings: deviceSettings}, this.props.slide,
                    rescanIslands[i]["islandBoundary"]["x"] + rescanIslands[i]["islandBoundary"]["width"],
                    y_fields - rescanIslands[i]["islandBoundary"]["y"] -
                    rescanIslands[i]["islandBoundary"]["height"]);
                let bounds = [
                    [rectStartPoint.x, rectStartPoint.y],
                    [rectEndPoint.x, rectStartPoint.y],
                    [rectEndPoint.x, rectEndPoint.y],
                    [rectStartPoint.x, rectEndPoint.y],
                    [rectStartPoint.x, rectStartPoint.y]
                ];
                index = (index + 1) % 4;
                drawRectangle(bounds, this.layer.getSource(), false, 4, TileViewerConstants.BLUE[index],
                    "", textColor);
            }
        }
        if (islands.length > 0 && islands[0]["counties"]) {
            plotCounties(islands, {device_settings: deviceSettings}, this.props.slide,
                this.layer.getSource(), 1, textColor);
        }
        resolve();
    });
}

export default RescanIslands;
